<template>
  <section class="obra-author-card" aria-labelledby="obra-author-title">
    <div class="obra-section-heading">
      <span class="obra-section-heading__eyebrow">Autor</span>
      <h2 id="obra-author-title">Sobre o autor</h2>
    </div>
    <div class="obra-author-card__body">
      <div v-if="safeAuthor.id" class="obra-author-card__identity">
        <router-link
          class="obra-author-card__avatar-link"
          :to="`/autor/${safeAuthor.id}`"
          :aria-label="`Abrir perfil de ${displayName}`"
        >
          <v-avatar size="56" class="obra-author-card__avatar">
            <img v-if="safeAuthor.profile_photo" :src="safeAuthor.profile_photo" :alt="`Foto do autor ${displayName}`" @contextmenu.prevent />
            <v-icon v-else color="#d9d9d9">mdi-account</v-icon>
          </v-avatar>
        </router-link>
        <span class="obra-author-card__text">
          <span class="obra-author-card__name-row">
            <router-link class="obra-author-card__name" :to="`/autor/${safeAuthor.id}`">
              {{ displayName }}
            </router-link>
            <v-btn small rounded outlined class="zinnes-primary-btn" @click="$emit('follow-author', safeAuthor.id)">
              {{ safeAuthor.is_follow ? 'Seguindo' : 'Seguir' }}
            </v-btn>
          </span>
          <span v-if="safeAuthor.nickname" class="obra-author-card__handle">@{{ safeAuthor.nickname }}</span>
        </span>
      </div>
      <span v-else class="obra-author-card__identity">
        <v-avatar size="56" class="obra-author-card__avatar">
          <v-icon color="#d9d9d9">mdi-account</v-icon>
        </v-avatar>
        <span class="obra-author-card__text">
          <strong>{{ displayName }}</strong>
        </span>
      </span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ObraAuthorCard',
  props: {
    author: { type: Object, default: () => ({}) },
  },
  computed: {
    safeAuthor() {
      return this.author || {};
    },
    displayName() {
      return this.safeAuthor.name || this.safeAuthor.nickname || 'Autor nao informado';
    },
  },
};
</script>
